export default function SVG_In_HTML() {
  return (
    <div>
      <h1>SVG_In_HTML Component</h1>
    </div>
  );
}
